// ###### IMPORTS
import { useDevice } from './DeviceContext';

// ###### RESPONSIVE DRAG HOOK
export const useResponsiveDrag = () => {
  const { isMobile, isTablet, touchCapable, screenSize } = useDevice();
  
  return {
    // ###### DRAG HANDLE CONFIGURATIONS
    dragHandleSize: '24px',
    dragHandleClass: 'w-6 h-6 bg-gray-100 rounded cursor-grab active:cursor-grabbing flex items-center justify-center transition-colors duration-200 hover:bg-gray-200 select-none',
    
    // ###### DROP ZONE CONFIGURATIONS
    dropZoneClass: isMobile
      ? 'min-h-[200px] p-4 border-2 border-dashed border-gray-300 rounded-lg transition-colors duration-200'
      : 'min-h-[400px] p-2 border-2 border-dashed border-gray-300 rounded-lg transition-colors duration-200',
    
    dropZoneActiveClass: 'border-blue-400 bg-blue-50',
    dropZoneHoverClass: 'hover:border-gray-400',
    
    // ###### DRAG BEHAVIOR CONFIGURATIONS
    activationDistance: isMobile ? 8 : 5,
    activationDelay: isMobile ? 2000 : 0,
    activationTolerance: isMobile ? 5 : 5,
    
    // ###### FEEDBACK VISUAL CONFIGURATIONS
    dragFeedbackClass: isMobile
      ? 'opacity-50 scale-105 shadow-2xl'
      : 'opacity-50 scale-105 shadow-lg',
    
    // ###### LAYOUT CONFIGURATIONS
    containerClass: isMobile
      ? 'w-full space-y-2'
      : 'flex flex-col md:flex-row gap-2',
    
    columnClass: isMobile
      ? 'w-full space-y-2'
      : 'w-full md:w-1/2 space-y-2',
    
    // ###### TASK CARD CONFIGURATIONS
    taskCardClass: isMobile
      ? 'w-full bg-white rounded-2xl shadow p-4 mb-2 transition-all duration-200 hover:shadow-lg'
      : 'w-full bg-white rounded-2xl shadow p-4 mb-2 transition-all duration-200 hover:shadow-lg md:w-full',
    
    // ###### MOBILE SPECIFIC CONFIGURATIONS
    isMobile,
    isTablet,
    isDesktop: !isMobile && !isTablet,
    screenSize,
    
    // ###### HAPTIC FEEDBACK (if available)
    hapticFeedback: isMobile && 'vibrate' in navigator,
    
    // ###### SCROLL PREVENTION
    preventScroll: isMobile,
    
    // ###### TOUCH GESTURES
    enableTouchGestures: touchCapable,
    longPressDelay: isMobile ? 500 : 0,
    
    // ###### DRAG HANDLE STYLES
    dragHandleStyle: isMobile ? {
      touchAction: 'none',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      WebkitTouchCallout: 'none'
    } : {}
  };
};
